import { StandingColumns } from "~pages/Standings/StandingsListPage/enums/standingColumns";
import type { StandingTransformed } from "~pages/Standings/types/standingTransformed";

const derivedValueGetters: Partial<Record<string, (row: StandingTransformed) => number | undefined>> = {
  [StandingColumns.Home]: ({ calculated }) => calculated?.OVERALL?.winsHome - calculated?.OVERALL?.lossesHome,
  [StandingColumns.Away]: ({ calculated }) => calculated?.OVERALL?.winsAway - calculated?.OVERALL?.lossesAway,
  [StandingColumns.Div]: ({ calculated }) => calculated?.IN_DIVISION?.wins - calculated?.IN_DIVISION?.losses,
  [StandingColumns.Conf]: ({ calculated }) => calculated?.IN_CONFERENCE?.wins - calculated?.IN_CONFERENCE?.losses,
};

// Column keys match the field names inside the OVERALL block of `calculated` / `points`
export const getStandingSortValue = (row: StandingTransformed, key: string, dataIndex: "calculated" | "points") => {
  const derivedValueGetter = derivedValueGetters[key];
  if (derivedValueGetter) {
    return derivedValueGetter(row);
  }

  const value = (row[dataIndex]?.OVERALL as Record<string, unknown> | undefined)?.[key];
  return typeof value === "number" ? value : undefined;
};
